/* storybook-check-ignore */
import { colors } from '@opendoor/bricks/theme/eero';

interface Props {
  fill?: string;
  width?: number;
  height?: number;
  className?: string;
  alt: string;
}

const InfoIcon = (props: Props) => {
  return (
    <svg
      {...props}
      fill={props.fill || colors.neutrals100}
      width={props.width || '100%'}
      height={props.height || '100%'}
      viewBox="0 0 24 24"
    >
      <path d="M12 5.95122C8.65935 5.95122 5.95122 8.65935 5.95122 12C5.95122 15.3406 8.65935 18.0488 12 18.0488C15.3406 18.0488 18.0488 15.3406 18.0488 12C18.0488 8.65935 15.3406 5.95122 12 5.95122ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM10.8293 12C10.8293 11.5689 11.1787 11.2195 11.6098 11.2195H12.3902C12.8213 11.2195 13.1707 11.5689 13.1707 12V15.122C13.1707 15.553 12.8213 15.9024 12.3902 15.9024H11.6098C11.1787 15.9024 10.8293 15.553 10.8293 15.122V12ZM12 10.439C11.3534 10.439 10.8293 9.91487 10.8293 9.26829C10.8293 8.62172 11.3534 8.09756 12 8.09756C12.6466 8.09756 13.1707 8.62172 13.1707 9.26829C13.1707 9.91487 12.6466 10.439 12 10.439Z" />
    </svg>
  );
};

export default InfoIcon;
